import React, { useEffect, useRef } from "react";
import { useState } from "react";
import "./index.css";
import { Form, FormGroup, Table } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation ,useParams} from "react-router-dom";
import { Formik } from "formik";
import SvgImage from "../../../Icons/Icons";
import { DatePickerField } from "../../../core/inputs/input";
import moment from "moment";
import { Button } from "reactstrap";
import Switch from "react-switch";
import Collapsible from "react-collapsible"
import ProfileUpdateRender from "../profileUpdateRender"
import ImageModal from "../../imageModal";
import { getSignedUrlApiAction } from "../../../../services/Store/Actions/appActions";
import ServiceHistory from "../serviceHistory";

function ProfileItems(props) {
  const dispatch = useDispatch();

    const { type,value ,expenseType} = props
    let { id } = useParams();
    const fleetId = id
    const { advancedVehicleList } = useSelector(
      (state) => state?.fleet
    );
    const vehicle = advancedVehicleList?.filter(
      (element) => element.fleetId == fleetId
    )[0];
    console.log("vehicle", vehicle, fleetId);
    console.log("keyvaluedata ProfileItems",type, value ,expenseType);
    const vehicleServiceData = useSelector((state) => state?.fleet?.vehicleProfileData?.serviceData);
    console.log("vehicleServiceData22",vehicleServiceData);
    const [serviceItem, setServiceItem] = useState({})
    useEffect(()=>{
       
      if(vehicleServiceData.length > 0 && vehicleServiceData[0].fleetId == fleetId) {
       const data = vehicleServiceData.find(elem => elem.expenseType == expenseType)
        if(data){
            setServiceItem(data)
            setCreate(false)
            setRenderType("showItem")
          }
     }
     console.log("Mount_ProfileItem",type,create,renderType,serviceItem,vehicleServiceData);
    },[vehicleServiceData])
    useEffect(()=>{
      return () => {
        setCreate(true)
        setRenderType("create")
        setServiceItem({})
        console.log("Unmount_ProfileItem",type, create,renderType,serviceItem,vehicleServiceData);
      }
    },[vehicleServiceData])
    console.log("vehicleServiceData_ProfileItems",serviceItem, expenseType);

    const [imageUrl, setImageUrl] = useState('');


    const [imageModal, setImageModal] = useState(false);
    const closeImageModal = () => {
        setImageModal(false);
    };
    const toggleImageModal = () => {
        setImageModal(!imageModal);
    }
    const handleClick = (type) => () => {
      setRenderType(type)
    }
    useEffect(() => {
      if(serviceItem?.imageUrl && !imageUrl){
        dispatch(
          getSignedUrlApiAction(
            { key: serviceItem?.imageUrl},
            (res) => {
              // setDownloadLoader2(false);
              // setLoaderInvoiceId("");
              if (res.status == 200) {
                  setImageUrl(res?.data?.data)
              }
            }
          )
        );
      }
  },[serviceItem])
  const printDocument = () => {
    window.open(imageUrl)
  }
  const [create, setCreate] = useState(serviceItem?.VehicleProfileId? false : true);
  const [renderType, setRenderType] = useState(serviceItem?.VehicleProfileId? 'showItem' : 'create')

  const distanceLeft = (serviceItem?.odometer + serviceItem?.expectedDuration - vehicle?.currentOdometer) < 0 ? 0 : (serviceItem?.odometer + serviceItem?.expectedDuration - vehicle?.currentOdometer)
  const styleFont = distanceLeft < parseInt(serviceItem?.expectedDuration * .1) ? {color: "red"}: distanceLeft < parseInt(serviceItem?.expectedDuration * .2) ? {color: "orange"}: {color: "green"}
  console.log("distanceLeft",distanceLeft,"data?.odometer",serviceItem?.odometer,"data?.expectedDuration",serviceItem?.expectedDuration,"vehicle.currentOdometer",vehicle?.currentOdometer);
    return  (<div>
              <Collapsible
                trigger={
                  <div
                    className="ServiceList"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      height: "40px",
                      paddingLeft: "10px",
                      paddingRight: "10px",
                    }}
                  >
                    <div className="heading3 semiBold"><p6>{value }</p6></div>
                    {!create ? (<div style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-around",
                      alignItems: "center",
                      // color:"green",
                      ...styleFont
                    }}>
                        <div >
                        Distance Left Before Next Service: 
                        </div>
                        <div>
                            {distanceLeft + "  Km"}
                        </div>
                    </div>): <></>}
                  </div>

                }
                // onClosing={()=> closeUpdate()}
              >
                {!create ? (<div style={{ margin: "10px" }}>
              
                <div style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-start",
                    }}>
                      <button
                            className={renderType == "showItem" ? "activeTab tab1" : "inActiveTab tab1"}
                            // style={{width: "60px", height:"25px",borderRadius: "5px",backgroundColor: "#FFF",borderColor: "#2E7C7B",}}
                            onClick={handleClick("showItem")}
                        >
                            <text>Current Service</text>
                        </button>
                        <button
                            className={renderType == "add" ? "activeTab tab1" : "inActiveTab tab1"}
                            // style={{width: "60px", height:"25px",borderRadius: "5px",backgroundColor: "#FFF",borderColor: "#2E7C7B",}}
                            onClick={handleClick("add")}
                        >
                            <text>Add New Service</text>
                        </button>
                        <button
                            className={renderType == "showHistory" ? "activeTab tab1" : "inActiveTab tab1"}
                            // style={{width: "60px", height:"25px",borderRadius: "5px",backgroundColor: "#FFF",borderColor: "#2E7C7B",}}
                            onClick={handleClick("showHistory")}
                        >
                            <text>Service History</text>
                        </button>
                       
                </div>
                </div>): <></>}
                {/* {!create && renderType == "showItem" ? (<div style={{ margin: "10px" }}>
                  <div style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      paddingTop: "10px"
                    }}>
                        <div>
                        Last Service Date:
                        </div>
                        <div>
                            {serviceItem?.serviceDate}
                        </div>
                        <div>
                        Remarks:
                        </div>
                        <div>
                            {serviceItem?.remarks}
                        </div>
                    </div>
                    <div style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      paddingTop: "10px"
                    }}>
                        <div>
                        Last Service Cost: 
                        </div>
                        <div>
                            {serviceItem?.price + "  Rs"}
                        </div>
                        <div>
                        Expected Distance:
                        </div>
                        <div>
                            {serviceItem?.expectedDuration+ "  Km"}
                        </div>
                    </div>
                    <div style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      paddingTop: "10px"
                    }}>
                        <div>
                        TagId: 
                        </div>
                        <div>
                            {serviceItem?.tagId || "" }
                        </div>
                        <div onClick={()=>{ setImageModal(true)}} style={{color: "blue", cursor: "pointer"}}>
                        Image:
                        </div>
                        <div>
                        {imageUrl ? <div onClick={printDocument} style={{ paddingRight: "5px" }}>
                                <SvgImage name="downloadImg" width="24" height="24" />
                            </div>: <></>}
                        </div>
                    </div>
                    <div style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      paddingTop: "10px"
                    }}>
                        <div>
                        Last Odometer Reading: 
                        </div>
                        <div>
                            {serviceItem?.odometer + "  Km"}
                        </div>
                        <div>
                        
                        </div>
                        <div>
                           
                        </div>
                    </div>
                </div> ): ["edit", "add", "create","showItem"].includes(renderType) ? (<div> */}
                {["edit", "add", "create","showItem"].includes(renderType) ? (<div> 
                    <ProfileUpdateRender
                        type={type}
                        value={value}
                        data={serviceItem}
                        fleetId={fleetId}
                        create={create}
                        renderType={renderType}
                    />
                </div>): !create &&  renderType == "showHistory" ? (<ServiceHistory
                        fleetId={fleetId}
                        expenseType={expenseType}
                        type={type}
                        value={value}
                />): <></>}
              </Collapsible>
              <ImageModal
                toggle={toggleImageModal}
                imageModal={imageModal}
                setImageModal={setImageModal}
                image={imageUrl.split('?')[0]}
              />
            </div> )
}
export default ProfileItems;


